import { createFileRoute } from '@tanstack/react-router'

import { preloadListSuppliers } from '@/api/react-query'
import { paginatedSearchWithSort } from '@/utils/route-utilities'

export const Route = createFileRoute('/_authenticated/_general/inventory/suppliers')({
	validateSearch: paginatedSearchWithSort(['name', 'currencyCode', 'email', 'externalId']),
	loaderDeps: ({ search: { limit, offset, q, sortBy, sortOrder } }) => ({ limit, offset, q, sortBy, sortOrder }),
	loader: async ({ context, deps: { limit, offset, q, sortBy, sortOrder } }) =>
		await preloadListSuppliers(context, { query: { limit, offset, q, sortBy, sortOrder } }),
	staticData: {
		crumb: ({ context: { L } }) => L.Inventory.Suppliers()
	}
})
